export default __webpack_public_path__ + "static/media/online-shop-1.29c18288.png";